function normalizeBase64Padding(value) {
    const remainder = value.length % 4;
    if (remainder === 0) {
        return value;
    }
    return value + '='.repeat(4 - remainder);
}
export function toArrayBuffer(value) {
    if (value instanceof ArrayBuffer) {
        return value;
    }
    const buffer = new ArrayBuffer(value.byteLength);
    new Uint8Array(buffer).set(new Uint8Array(value.buffer, value.byteOffset, value.byteLength));
    return buffer;
}
export function decodeBase64Url(value) {
    const base64 = normalizeBase64Padding(value.replaceAll('-', '+').replaceAll('_', '/'));
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
        bytes[index] = binary.charCodeAt(index);
    }
    return bytes;
}
export function encodeBase64Url(value) {
    const bytes = value instanceof Uint8Array ? value : new Uint8Array(value);
    let binary = '';
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}
